.categories {
  display: flex;
  flex-wrap: wrap;
  gap: 16px 24px;
}
